import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { BlueOnClick } from "../common/Button";
import { withStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import AppContainer from "../common/AppContainer";
import * as authActions from "../auth/actions";
import * as navActions from "../common/actions";
import BreadcrumbNav from "../common/BreadCrumb";
import InputAdornment from "@material-ui/core/InputAdornment";
import { GroundwaterExtraction } from "./models";
import { createSelector } from "../common/orm";
import HelpLabel from "../common/HelpLabel";
import NumberFormat from "react-number-format";
/* Calc Method Start */
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
const getOptions = GroundwaterExtraction.getOptions();
const CalcMethod = (props) => {
  // props: fieldName, currentValue
  const [value, setValue] = React.useState(props.currentValue); // eslint-disable-line no-unused-vars
  /* TODO: Figure out how to set the field's value so that the value of the field and make sure the form can read it */
  return (
    <FormControl component="fieldset">
      <RadioGroup
        style={{ flexWrap: "nowrap", marginLeft: "10px" }}
        aria-label="direct"
        name={props.fieldName}
        row
      >
        <FormControlLabel
          value="Direct"
          disabled={props.disabled}
          onChange={props.onChange}
          style={{ alignItems: "center" }}
          control={
            <Radio
              checked={props.value === "Direct"}
              style={{
                padding: "6px 0px 3px 7px",
                color: props.value === "Direct" ? "#13aff1" : "",
              }}
            />
          }
          label="Direct"
          labelPlacement="end"
        />
        <FormControlLabel
          value="Estimated"
          disabled={props.disabled}
          onChange={props.onChange}
          style={{ alignItems: "center" }}
          control={
            <Radio
              checked={props.value === "Estimated"}
              style={{
                padding: "6px 0 3px 7px",
                color: props.value === "Estimated" ? "#13aff1" : "",
              }}
            />
          }
          label="Estimated"
          labelPlacement="end"
        />
      </RadioGroup>
    </FormControl>
  );
};
/* Calc Method End */
const getUserData = createSelector(
  (state, ownProps) => ({
    id: state.auth && state.auth.user ? state.auth.user.id : {},
    gsp: parseInt(ownProps.match.params["gsp"]),
  }),
  (session, options) => {
    let user = session.User.filter((u) => u.id === options.id).toRefArray()[0];
    let association = session.GSPAssociation.filter(
      (u) => u.user === options.id && u.gsp === options.gsp
    ).toRefArray()[0];
    let gsp = association
      ? session.GSP.filter((u) => u.id === association.gsp).toRefArray()[0]
      : {};
    return user && association && gsp
      ? {
          ...user,
          association: association ? association : {},
          gsp: gsp ? gsp : {},
        }
      : {};
  }
);
function formatDate(date) {
  var monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  var day = date.getUTCDate();
  var monthIndex = date.getUTCMonth();
  var year = date.getUTCFullYear();
  return monthNames[monthIndex] + " " + day + ", " + year;
}
const getWaterYear = createSelector((session, id) => {
  let wy = session.WaterYear.filter(
    (y) => y.is_active === true
  ).toRefArray()[0];
  return {
    ...wy,
  };
});
const currentGroundwaterExtraction = createSelector(
  (state, ownProps) => ({
    id: state.auth && state.auth.user ? state.auth.user.id : {},
    gsp: parseInt(ownProps.match.params["gsp"]),
    ge_id: parseInt(ownProps.match.params["id"]),
  }),
  (session, options) => {
    let gsp = session.GSP.filter((u) => u.id === options.gsp).toRefArray()[0];

    let thisWaterYear = session.WaterYear.filter(
      (y) => y.is_active === true
    ).toRefArray()[0];

    if (options.ge_id && gsp) {
	 
      let ge = session.GroundwaterExtraction.filter(
        (y) => y.gsp_name_id === gsp.id && y.id === options.ge_id
      ).toRefArray()[0];

      let wy =
        ge && ge.water_year_id
          ? session.WaterYear.filter(
              (y) => y.id === ge.water_year_id
            ).toRefArray()[0]
          : {};

      ge = { ...ge, wy: wy };

      return gsp && ge && wy ? ge : {};
    } else {
      return gsp && thisWaterYear
        ? session.GroundwaterExtraction.filter(
            (y) => y.water_year_id === thisWaterYear.id && y.gsp === gsp.id
          ).toRefArray()[0]
        : {};
    }
  }
);
const historicGroundwaterExtraction = createSelector(
  (state, ownProps) => ({
    id: state.auth && state.auth.user ? state.auth.user.id : {},
    gsp: parseInt(ownProps.match.params["gsp"]),
  }),
  (session, options) => {
    let association = session.GSPAssociation.filter(
      (u) => u.user === options.id && u.gsp === options.gsp
    ).toRefArray()[0];

    let gsp = association
      ? session.GSP.filter((u) => u.id === association.gsp).toRefArray()[0]
      : {};

    let thisWaterYear = session.WaterYear.filter(
      (y) => y.is_active === true
    ).toRefArray()[0];

    return thisWaterYear && gsp
      ? session.GroundwaterExtraction.filter(
          (y) => y.water_year_id !== thisWaterYear.id && y.gsp_name_id_id === gsp.id
        ).toRefArray()
      : {};
  }
);
const styles = (theme) => ({
  container: {
    paddingLeft: "10px",
  },
  hrclass: {
    borderColor: "primary",
  },
  tc: {
    padding: "4px 4px 4px 4px",
    maxWidth: "60px",
  },
  tcNumber: {
    padding: "4px 4px 4px 4px",
    maxWidth: "40px",
  },
  tcAccuracy: {
    padding: "4px 4px 4px 15px",
    maxWidth: "20px",
  },
  mdHeader: {
    fontSize: "18px",
    textDecoration: "underline",
    fontWeight: "normal",
  },
  lgHeader: {
    fontSize: "25px",
  },
});
class ReportingGWExtraction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      csrftoken: localStorage.auth_token,
      loader: null,
      agency: "Not Available",
      waterYearStart: "Not Available",
      waterYearEnd: "Not Available",
      districtName: "Not Available",
      helpOpen: false,
      submitted: false,
      saved: false,
      authorized: false,
      callOptions: false,
      gw_use_ua_total: "",
      gw_use_la_total: "",
      gw_use_total_total: "",
      gw_aquifier_total: "",
      // Default Values
      gw_agg_ua: 0,
      gw_agg_la: 0,
      gw_agg_total: 0,
      gw_agg_acc: "",
      gw_dom_ua: 0,
      gw_dom_la: 0,
      gw_dom_total: 0,
      gw_dom_acc: "",
      gw_ind_ua: 0,
      gw_ind_la: 0,
      gw_ind_total: 0,
      gw_ind_acc: "",
      gw_wet_ua: 0,
      gw_wet_la: 0,
      gw_wet_total: 0,
      gw_wet_acc: "",
      gw_out_ua: 0,
      gw_out_la: 0,
      gw_out_total: 0,
      gw_out_acc: "",
      gw_mr_ua: 0,
      gw_mr_la: 0,
      gw_mr_total: 0,
      gw_mr_acc: "",
      gw_veg_ua: 0,
      gw_veg_la: 0,
      gw_veg_total: 0,
      gw_veg_acc: "",
      gw_other_ua: 0,
      gw_other_la: 0,
      gw_other_total: 0,
      gw_other_acc: "",
      water_year_id: null,
      gsp_id: null,
      curdata: false,
    };
  }
  componentDidMount() {
    const { authState, history } = this.props;
    if (authState && authState.user && authState.user.role === "Agency") {
      history.push("/dashboard");
    }
  }
  populateStateFromHistory = () => {
    const { watercur, user } = this.props;
    if (watercur && watercur.id && !this.state.curdata) {
      let isAuth = false;
      if (
        user &&
        user.association &&
        user.association.authorized_reporter &&
        user &&
        user.role === "GSP Representative"
      ) {
        isAuth = true;
      }
      if (watercur.submitted || isAuth) {
        this.setState({
          ...this.state,
          ...watercur,
          curdata: true,
          authorized: isAuth,
        });
      }
    }
  };
  setAuthorized = () => {
    const { user } = this.props;
    const { authorized } = this.state;
    if (user && user.association && user.association.authorized_reporter) {
      if (!authorized && user && user.role === "GSP Representative") {
        this.setState({ authorized: true });
      }
    }
  };
  pf = (val) => {
    if (val === "" || val === " " || val === null) {
      return parseFloat(0);
    } else if (typeof val === "string") {
      return parseFloat(val.replace(/,/g, ""));
    } else {
      return parseFloat(val);
    }
  };
  MAP_OPTIONS = (table) => {
    var t = table.map((row) => ({
      label: row.display_name,
      value: row.value,
    }));
    return t;
  };
  componentDidUpdate(prevProps, prevState, snapshot) {
    /* Auto-calculating fields after they're updated */
    const {
      gw_agg_ua,
      gw_agg_la,
      gw_agg_total,
      gw_dom_ua,
      gw_dom_la,
      gw_dom_total,
      gw_ind_ua,
      gw_ind_la,
      gw_ind_total,
      gw_wet_ua,
      gw_wet_la,
      gw_wet_total,
      gw_out_ua,
      gw_out_la,
      gw_out_total,
      gw_mr_ua,
      gw_mr_la,
      gw_mr_total,
      gw_veg_ua,
      gw_veg_la,
      gw_veg_total,
      gw_other_ua,
      gw_other_la,
      gw_other_total,
    } = this.state;
    // Totals
    if (
      prevState.gw_agg_ua !== gw_agg_ua ||
      prevState.gw_dom_ua !== gw_dom_ua ||
      prevState.gw_ind_ua !== gw_ind_ua ||
      prevState.gw_wet_ua !== gw_wet_ua ||
      prevState.gw_out_ua !== gw_out_ua ||
      prevState.gw_mr_ua !== gw_mr_ua ||
      prevState.gw_veg_ua !== gw_veg_ua ||
      prevState.gw_other_ua !== gw_other_ua
    ) {
      this.setState({
        gw_use_ua_total:
          this.pf(gw_agg_ua) +
          this.pf(gw_dom_ua) +
          this.pf(gw_ind_ua) +
          this.pf(gw_wet_ua) +
          this.pf(gw_out_ua) +
          this.pf(gw_mr_ua) +
          this.pf(gw_veg_ua) +
          this.pf(gw_other_ua),
      });
    }
    if (
      prevState.gw_agg_la !== gw_agg_la ||
      prevState.gw_dom_la !== gw_dom_la ||
      prevState.gw_ind_la !== gw_ind_la ||
      prevState.gw_wet_la !== gw_wet_la ||
      prevState.gw_out_la !== gw_out_la ||
      prevState.gw_mr_la !== gw_mr_la ||
      prevState.gw_veg_la !== gw_veg_la ||
      prevState.gw_other_la !== gw_other_la
    ) {
      this.setState({
        gw_use_la_total:
          this.pf(gw_agg_la) +
          this.pf(gw_dom_la) +
          this.pf(gw_ind_la) +
          this.pf(gw_wet_la) +
          this.pf(gw_out_la) +
          this.pf(gw_mr_la) +
          this.pf(gw_veg_la) +
          this.pf(gw_other_la),
      });
    }
    if (
      prevState.gw_agg_total !== gw_agg_total ||
      prevState.gw_dom_total !== gw_dom_total ||
      prevState.gw_ind_total !== gw_ind_total ||
      prevState.gw_wet_total !== gw_wet_total ||
      prevState.gw_out_total !== gw_out_total ||
      prevState.gw_mr_total !== gw_mr_total ||
      prevState.gw_veg_total !== gw_veg_total ||
      prevState.gw_other_total !== gw_other_total
    ) {
      this.setState({
        gw_use_total_total:
          this.pf(gw_agg_total) +
          this.pf(gw_dom_total) +
          this.pf(gw_ind_total) +
          this.pf(gw_wet_total) +
          this.pf(gw_out_total) +
          this.pf(gw_mr_total) +
          this.pf(gw_veg_total) +
          this.pf(gw_other_total),
      });
    }
  }
  NumberFormatCustom = (props) => {
    const { inputRef, onChange, ...other } = props;
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values) => {
          onChange({
            target: {
              value: values.value,
              name: other.name,
            },
          });
        }}
        thousandSeparator
      />
    );
  };
  handleChange = (evt) => {
    this.setState({
      [evt.target.name]: evt.target.value,
    });
  };
  handleChangeNumeric = (evt) => {
    const re = /^-?[-0-9\b]+$/;
    if (evt.target.value === "" || re.test(evt.target.value)) {
      this.setState({
        [evt.target.name]: evt.target.value,
      });
    }
  };
  handleSave = (evt) => {
    evt.preventDefault();
    const {
      ormGroundwaterExtractionCreate,
      ormGroundwaterExtractionUpdate,
    } = this.props;
    const { user, wateryr, history } = this.props;
    const { curdata } = this.state;
    this.setState({
      submitted: false,
      saved: true,
      water_year_id: wateryr.id,
      gsp_id: user.gsp.id,
    });
    const stObj = {
      ...this.state,
      submitted: false,
      saved: true,
      water_year_id: wateryr.id,
      gsp_id: user.gsp.id,
    };
    if (!curdata) {
      ormGroundwaterExtractionCreate(stObj);
    } else {
      ormGroundwaterExtractionUpdate(stObj);
    }
    history.push("/reporting");
  };
  submitForm = (evt) => {
    evt.preventDefault();
    const { ormGroundwaterExtractionUpdate, history } = this.props;
    this.setState({
      submitted: true,
    });
    const stObj = {
      ...this.state,
      submitted: true,
    };
    ormGroundwaterExtractionUpdate(stObj);
    history.push("/reporting");
  };
  render() {
    this.setAuthorized();
    this.populateStateFromHistory();
    const {
      submitted,
      saved,
      gw_use_ua_total,
      gw_use_la_total,
      gw_use_total_total,
      authorized,
      helpOpen,
      siteChoices,
      callOptions,
    } = this.state;
    const {
      classes,
      user,
      wateryr,
      watercur,
      waterhist,
      optionsReq,
    } = this.props;
    let submitActive =
      (saved || this.state.curdata) && !submitted && authorized;
    //OPTIONS comes back as a promise
    if (optionsReq && !siteChoices) {
      optionsReq.then((data) => {
        if (!this.state.siteChoices) {
          this.setState({
            siteChoices: data,
          });
        }
      });
    }
    return (
      <AppContainer authenticated>
        <div className={classes.container}>
          <form>
            {watercur && watercur.wy ? (
              <>
                <BreadcrumbNav
                  level1="Groundwater Extraction"
                  level1link="/groundwaterextraction"
                  level2="Groundwater Extraction Details"
                  level2link={
                    "/reporting/gwextraction/" +
                    this.props.match.params["gsp"] +
                    "/" +
                    this.props.match.params["id"]
                  }
                />
                <br />
              </>
            ) : (
              <>
                <BreadcrumbNav
                  level1="Associated GSP's"
                  level1link="/reporting"
                  level2="Report Groundwater (Extraction) Data"
                  level2link={
                    "/reporting/gwextraction/" + this.props.match.params["gsp"]
                  }
                />
                <br />
              </>
            )}
            <Grid container spacing={24}>
              <Grid item xs={12}>
                {watercur && watercur.wy && (
                  <>
                    <span className={classes.lgHeader}>
                      Water Year:{" "}
                      {watercur.wy.water_year}{" "}
                      / Measurement Month:{" "}
                      {watercur.measurement_month}
                      
                    </span>
                  </>
                )}
                 {/* : (   TODO: when does this ocur???? 
                  <>
                    <hr className={classes.hrclass} />
                    <span className={classes.lgHeader}>
                      Date:{" "}
                      {wateryr
                        ? new Date(
                            wateryr.water_year_start + " "
                          ).toLocaleDateString("en-US")
                        : ""}{" "}
                      -{" "}Submitted GW Recharge Data
                      {wateryr
                        ? new Date(
                            wateryr.water_year_end + " "
                          ).toLocaleDateString("en-US")
                        : ""}
                    </span>
                  </>
                )} */}
              </Grid>
              {watercur && watercur.gsp_name_label && (
                <Grid item xs={12}>
                  <>
                    <span>
                        <b>GSP:</b> {watercur.gsp_name_label}  
                    </span>
                    <span style={{marginLeft:4}}>
                        {"  |  "}<b> GSA: </b>{watercur.gsa_name_label}
                    </span>
                  </>
                </Grid>
              )}
              {watercur && watercur.wy ? (
                <></>
              ) : (
                <>
                  <Grid item xs={12}>
                    <b>Role:</b> Your user account is{" "}
                    {authorized ? "currently" : <b>NOT</b>} authorized to report
                    data for:{" "}
                    <b>
                      {user && user.gsp
                        ? user.gsp.name
                        : "(User not associated with GSP)"}
                    </b>
                    .
                  </Grid>
                  <Grid item xs={12}>
                    <b>Status:</b> {submitted ? "Data" : "No data"} has been
                    imported into the DMS for the current water year.{" "}
                    {waterhist && waterhist.length && user && user.gsp ? (
                      <a
                        href={
                          "/#/reportinghistory/groundwaterextraction/" +
                          this.props.match.params["gsp"]
                        }
                      >
                        View Historic Data
                      </a>
                    ) : (
                      ""
                    )}
                  </Grid>
                </>
              )}
              <Grid item xs={12}>
                <hr className={classes.hrclass} />
                <h2 className={classes.mdHeader}>
                  Groundwater (Extraction) Data
                  <HelpLabel
                    open={helpOpen}
                    question="Groundwater Extraction"
                    showHelp={true}
                    inputLabel={true}
                    helpText={
                      <>Groundwater pumped for use by each water use sector.</>
                    }
                  />
                </h2>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell xs={3} className={classes.tcNumber}>
                        Water Use Sector
                        <HelpLabel
                          open={helpOpen}
                          question="Water Use Sector"
                          showHelp={true}
                          inputLabel={true}
                          helpText={
                            <>
                              Categories of water demand based on the general
                              land uses to which the water is applied, including
                              urban, industrial, agricultural, managed wetlands,
                              managed recharge, and native vegetation.
                            </>
                          }
                        />
                      </TableCell>
                      <TableCell xs={2} className={classes.tcNumber}>
                        Total
                      </TableCell>
                      <TableCell xs={3} className={classes.tc}>
                        Measurement Type
                      </TableCell>
                      <TableCell xs={2} className={classes.tcAccuracy}>
                        Measurement Accuracy
                      </TableCell>
                      <TableCell xs={2} className={classes.tcAccuracy}>
                        Measurement Method
                      </TableCell>
                      <TableCell xs={2} className={classes.tcAccuracy}>
                        Measurement Method Description
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell xs={3} className={classes.tcNumber}>
                        Urban/Domestic:
                      </TableCell>
                      <TableCell xs={1} className={classes.tcNumber}>
                        <TextField
                          name="gw_dom_total"
                          disabled={submitted || !authorized}
                          value={this.state.gw_dom_total}
                          onChange={this.handleChangeNumeric}
                          fullWidth
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">AF</InputAdornment>
                            ),
                            inputComponent: this.NumberFormatCustom,
                          }}
                        />
                      </TableCell>
                      <TableCell xs={3} className={classes.tc}>
                        {siteChoices ? (
                          <Select
                            name="gw_dom_calcm"
                            value={this.state.gw_dom_calcm}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_dom_calcm.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tcAccuracy}>
                        {siteChoices ? (
                          <Select
                            name="gw_dom_acc"
                            value={this.state.gw_dom_acc}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_dom_acc.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tcAccuracy}>
                        {siteChoices ? (
                          <Select
                            name="gw_dom_method"
                            value={this.state.gw_dom_method}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_dom_method.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tc}>
                        <TextField
                          name="gw_dom_method_notes"
                          disabled={submitted || !authorized}
                          value={this.state.gw_dom_method_notes}
                          onChange={this.handleChange}
                          multiline={true}
                          rows={1}
                          rowsMax="4"
                          inputProps={{
                            maxLength: 4000,
                          }}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell xs={3} className={classes.tcNumber}>
                        Industrial:
                      </TableCell>
                      <TableCell xs={1} className={classes.tcNumber}>
                        <TextField
                          name="gw_ind_total"
                          disabled={submitted || !authorized}
                          value={this.state.gw_ind_total}
                          onChange={this.handleChangeNumeric}
                          fullWidth
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">AF</InputAdornment>
                            ),
                            inputComponent: this.NumberFormatCustom,
                          }}
                        />
                      </TableCell>
                      <TableCell xs={3} className={classes.tc}>
                        {siteChoices ? (
                          <Select
                            name="gw_ind_calcm"
                            value={this.state.gw_ind_calcm}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_ind_calcm.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tcAccuracy}>
                        {siteChoices ? (
                          <Select
                            name="gw_ind_acc"
                            value={this.state.gw_ind_acc}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_ind_acc.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tcAccuracy}>
                        {siteChoices ? (
                          <Select
                            name="gw_ind_method"
                            value={this.state.gw_ind_method}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_ind_method.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tc}>
                        <TextField
                          name="gw_ind_method_notes"
                          disabled={submitted || !authorized}
                          value={this.state.gw_ind_method_notes}
                          onChange={this.handleChange}
                          multiline={true}
                          rows={1}
                          rowsMax="4"
                          inputProps={{
                            maxLength: 4000,
                          }}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell xs={3} className={classes.tcNumber}>
                        Agricultural:
                      </TableCell>
                      <TableCell xs={1} className={classes.tcNumber}>
                        <TextField
                          name="gw_agg_total"
                          disabled={submitted || !authorized}
                          value={this.state.gw_agg_total}
                          onChange={this.handleChangeNumeric}
                          fullWidth
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">AF</InputAdornment>
                            ),
                            inputComponent: this.NumberFormatCustom,
                          }}
                        />
                      </TableCell>
                      <TableCell xs={3} className={classes.tc}>
                        {siteChoices ? (
                          <Select
                            name="gw_agg_calcm"
                            value={this.state.gw_agg_calcm}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_agg_calcm.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tcAccuracy}>
                        {siteChoices ? (
                          <Select
                            name="gw_agg_acc"
                            value={this.state.gw_agg_acc}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_agg_acc.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tcAccuracy}>
                        {siteChoices ? (
                          <Select
                            name="gw_agg_method"
                            value={this.state.gw_agg_method}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_agg_method.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tc}>
                        <TextField
                          name="gw_agg_method_notes"
                          disabled={submitted || !authorized}
                          value={this.state.gw_agg_method_notes}
                          onChange={this.handleChange}
                          multiline={true}
                          rows={1}
                          rowsMax="4"
                          inputProps={{
                            maxLength: 4000,
                          }}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell xs={3} className={classes.tcNumber}>
                        Managed Wetlands:
                        <HelpLabel
                          open={helpOpen}
                          question="Managed Wetlands"
                          showHelp={true}
                          inputLabel={true}
                          helpText={
                            <>
                              Volume of Groundwater extracted and delivered (in
                              acre-feet) for programmatic management of
                              environmental uses, such as duck clubs, wildlife
                              refuges/areas, etc.
                            </>
                          }
                        />
                      </TableCell>
                      <TableCell xs={1} className={classes.tcNumber}>
                        <TextField
                          name="gw_wet_total"
                          disabled={submitted || !authorized}
                          value={this.state.gw_wet_total}
                          onChange={this.handleChangeNumeric}
                          fullWidth
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">AF</InputAdornment>
                            ),
                            inputComponent: this.NumberFormatCustom,
                          }}
                        />
                      </TableCell>
                      <TableCell xs={3} className={classes.tc}>
                        {siteChoices ? (
                          <Select
                            name="gw_wet_calcm"
                            value={this.state.gw_wet_calcm}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_wet_calcm.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tcAccuracy}>
                        {siteChoices ? (
                          <Select
                            name="gw_wet_acc"
                            value={this.state.gw_wet_acc}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_wet_acc.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tcAccuracy}>
                        {siteChoices ? (
                          <Select
                            name="gw_wet_method"
                            value={this.state.gw_wet_method}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_wet_method.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tc}>
                        <TextField
                          name="gw_wet_method_notes"
                          disabled={submitted || !authorized}
                          value={this.state.gw_wet_method_notes}
                          onChange={this.handleChange}
                          multiline={true}
                          rows={1}
                          rowsMax="4"
                          inputProps={{
                            maxLength: 4000,
                          }}
                        />
                      </TableCell>
                    </TableRow>
             
                    <TableRow>
                      <TableCell xs={3} className={classes.tcNumber}>
                        Managed Recharge:
                      </TableCell>
                      <TableCell xs={1} className={classes.tcNumber}>
                        <TextField
                          name="gw_mr_total"
                          disabled={submitted || !authorized}
                          value={this.state.gw_mr_total}
                          onChange={this.handleChangeNumeric}
                          fullWidth
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">AF</InputAdornment>
                            ),
                            inputComponent: this.NumberFormatCustom,
                          }}
                        />
                      </TableCell>
                      <TableCell xs={3} className={classes.tc}>
                        {siteChoices ? (
                          <Select
                            name="gw_mr_calcm"
                            value={this.state.gw_mr_calcm}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_mr_calcm.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tcAccuracy}>
                        {siteChoices ? (
                          <Select
                            name="gw_mr_acc"
                            value={this.state.gw_mr_acc}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_mr_acc.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tcAccuracy}>
                        {siteChoices ? (
                          <Select
                            name="gw_mr_method"
                            value={this.state.gw_mr_method}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_mr_method.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tc}>
                        <TextField
                          name="gw_mr_method_notes"
                          disabled={submitted || !authorized}
                          value={this.state.gw_mr_method_notes}
                          onChange={this.handleChange}
                          multiline={true}
                          rows={1}
                          rowsMax="4"
                          inputProps={{
                            maxLength: 4000,
                          }}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell xs={3} className={classes.tcNumber}>
                        Native Vegetation:
                      </TableCell>
                      <TableCell xs={1} className={classes.tcNumber}>
                        <TextField
                          name="gw_veg_total"
                          disabled={submitted || !authorized}
                          value={this.state.gw_veg_total}
                          onChange={this.handleChangeNumeric}
                          fullWidth
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">AF</InputAdornment>
                            ),
                            inputComponent: this.NumberFormatCustom,
                          }}
                        />
                      </TableCell>
                      <TableCell xs={3} className={classes.tc}>
                        {siteChoices ? (
                          <Select
                            name="gw_veg_calcm"
                            value={this.state.gw_veg_calcm}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_veg_calcm.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tcAccuracy}>
                        {siteChoices ? (
                          <Select
                            name="gw_veg_acc"
                            value={this.state.gw_veg_acc}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_veg_acc.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tcAccuracy}>
                        {siteChoices ? (
                          <Select
                            name="gw_veg_method"
                            value={this.state.gw_veg_method}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_veg_method.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tc}>
                        <TextField
                          name="gw_veg_method_notes"
                          disabled={submitted || !authorized}
                          value={this.state.gw_veg_method_notes}
                          onChange={this.handleChange}
                          multiline={true}
                          rows={1}
                          rowsMax="4"
                          inputProps={{
                            maxLength: 4000,
                          }}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell xs={3} className={classes.tcNumber}>
                        Other:
                      </TableCell>
                      <TableCell xs={1} className={classes.tcNumber}>
                        <TextField
                          name="gw_other_total"
                          disabled={submitted || !authorized}
                          value={this.state.gw_other_total}
                          onChange={this.handleChangeNumeric}
                          fullWidth
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">AF</InputAdornment>
                            ),
                            inputComponent: this.NumberFormatCustom,
                          }}
                        />
                      </TableCell>
                      <TableCell xs={3} className={classes.tc}>
                        {siteChoices ? (
                          <Select
                            name="gw_other_calcm"
                            value={this.state.gw_other_calcm}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_other_calcm.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tcAccuracy}>
                        {siteChoices ? (
                          <Select
                            name="gw_other_acc"
                            value={this.state.gw_other_acc}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_other_acc.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tcAccuracy}>
                        {siteChoices ? (
                          <Select
                            name="gw_other_method"
                            value={this.state.gw_other_method}
                            onChange={this.handleChange}
                            disabled={submitted || !authorized}
                            fullWidth
                          >
                            {this.MAP_OPTIONS(
                              siteChoices.gw_other_method.choices
                            ).map((o, i) => (
                              <MenuItem key={i} value={o.value}>
                                {o.label}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <div />
                        )}
                      </TableCell>
                      <TableCell xs={2} className={classes.tc}>
                        <TextField
                          name="gw_other_method_notes"
                          disabled={submitted || !authorized}
                          value={this.state.gw_other_method_notes}
                          onChange={this.handleChange}
                          multiline={true}
                          rows={1}
                          rowsMax="4"
                          inputProps={{
                            maxLength: 4000,
                          }}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell xs={3} className={classes.tcNumber}>
                        Other Use Description:
                      </TableCell>
                      <TableCell xs={2} className={classes.tc} colSpan={3}>
                        <TextField
                          name="gw_other_desc"
                          disabled={submitted || !authorized}
                          value={this.state.gw_other_desc}
                          onChange={this.handleChange}
                          multiline={true}
                          rows={1}
                          rowsMax="4"
                          inputProps={{
                            maxLength: 4000,
                          }}
                        />
                      </TableCell>
                      <TableCell xs={2} className={classes.tc}></TableCell>
                      <TableCell xs={2} className={classes.tc}></TableCell>
                      <TableCell xs={2} className={classes.tc}></TableCell>
                      <TableCell xs={2} className={classes.tc}></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell xs={3} className={classes.tcNumber}>
                        Total:
                      </TableCell>
                      <TableCell xs={1} className={classes.tcNumber}>
                        <TextField
                          name="gw_use_ua_total"
                          value={gw_use_ua_total}
                          disabled={true}
                          fullWidth
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">AF</InputAdornment>
                            ),
                            inputComponent: this.NumberFormatCustom,
                          }}
                        />
                      </TableCell>
                      <TableCell xs={1} className={classes.tcNumber}>
                        <TextField
                          name="gw_use_la_total"
                          value={gw_use_la_total}
                          disabled={true}
                          fullWidth
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">AF</InputAdornment>
                            ),
                            inputComponent: this.NumberFormatCustom,
                          }}
                        />
                      </TableCell>
                      <TableCell xs={2} className={classes.tcNumber}>
                        <TextField
                          name="gw_use_total_total"
                          value={gw_use_total_total}
                          disabled={true}
                          fullWidth
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">AF</InputAdornment>
                            ),
                            inputComponent: this.NumberFormatCustom,
                          }}
                        />
                      </TableCell>
                      <TableCell xs={3} className={classes.tc}></TableCell>
                      <TableCell
                        xs={2}
                        className={classes.tcAccuracy}
                      ></TableCell>
                      <TableCell xs={3} className={classes.tc}></TableCell>
                      <TableCell xs={2} className={classes.tc}></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Grid>
              {watercur && watercur.wy ? (
                <></>
              ) : (
                <>
                  <Grid item xs={3}>
                    <Button
                      fullWidth
                      variant="contained"
                      type="button"
                      label="Save"
                      disabled={submitted || !authorized}
                      onClick={this.handleSave}
                      style={{
                        backgroundColor:
                          !submitted && authorized ? "#13aff1" : "#7ed2f5",
                        color: "white",
                      }}
                    >
                      Save
                    </Button>
                  </Grid>
                  <Grid item xs={9}>
                    <Button
                      type="button"
                      onClick={this.submitForm}
                      disabled={!submitActive}
                      style={{
                        backgroundColor: submitActive ? "#13aff1" : "#7ed2f5",
                        color: "white",
                      }}
                    >
                      Submit Data as Final for Current Reporting Water Year
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </form>
        </div>
      </AppContainer>
    );
  }
}
ReportingGWExtraction = connect(
  (state, ownProps) => ({
    optionsReq: getOptions(state, ownProps),
    wateryr: getWaterYear(state, ownProps),
    user: getUserData(state, ownProps),
    watercur: currentGroundwaterExtraction(state, ownProps),
    waterhist: historicGroundwaterExtraction(state, ownProps),
    authState: state.auth,
  }),
  {
    ...GroundwaterExtraction.actions,
    ...authActions,
    ...navActions,
  }
)(ReportingGWExtraction);
export default withStyles(styles)(withRouter(ReportingGWExtraction));
